import OpenCloseAppHandler from '@/plugins/open-close-app-handler';

export default class CloseComponent {
	public closeApp(): void {
		OpenCloseAppHandler.closeApp();
	}
}
